<template>
  <v-container id="quantumsafe-sign-demo">
    <!-- HEADER -->
    <v-row justify="center" align="center">
      <v-btn
        id="cancel"
        class="elevation-0 pl-0 pr-3"
        color="black--text grey lighten-2"
        @click="$router.push('/signatureChains/list/ALL')"
      >
        <v-icon class="ma-0 pa-0" color="grey darken-3">
          mdi-chevron-left
        </v-icon>
        {{ $t("main.back") }}
      </v-btn>
      <v-col cols="7">
        <span id="filename-text" class="text-h5"> {{ $t("pqcDemo.title") }}</span>
      </v-col>

      <v-col class="d-flex flex-row justify-end">
        <v-btn

          id="sign-doc-button"
          color="success"
          class="mx-4 px-4"
          :disabled="singButtonDisabled"
          @click=" (selectedCredential.authMode === 'IMPLICIT')
            ? signDoc()
            : showAuthorizationModal()"
        >
          <v-icon class="mr-1 ml-0">mdi-draw-pen</v-icon>
          {{ $t("pqcDemo.signBtn") }}
        </v-btn>

        <v-btn

          id="clear-pdf-button"
          class="mx-4 px-4"
          color="error"
          :disabled="!selectedFile"
          :loading="isUploading"
          @click="clearPdf"
        >
          <v-icon class="mr-1 ml-0">mdi-close-circle-outline</v-icon>
          {{ $t("signatureDrawer.clear") }}
        </v-btn>
      </v-col>
    </v-row>
    <!-- /HEADER -->
    <!-- CONTENT -->

    <v-row>
      <v-col>
        <v-text-field
          id="upload_document_filename"
          v-model="fileName"
          :label="$t('main.name')"
        ></v-text-field>
        <v-select
          v-if="credentials.length > 0"
          id="signature_customization_credential_select"
          v-model="selectedCredential"
          class="mt-5"
          :items="credentials"
          :item-text="getCredentialItemText"

          :return-object="true"
          :label="$t('documentSignatureCustomization.content.signature.selectSigningCredential') + `*`"
          :rules="[rules.required]"
        >
          <!-- <template v-slot.item="{item}">
                      <div class="option_active_credential">
                        {{ item }}
                      </div>
                    </template> -->
        </v-select>
        <p v-show="showBlueWarning" class="BlueWarning">{{ $t('documentSignatureCustomization.warning.someCredendetialHaveProblem') }}</p>
      </v-col>

      <v-col>
        <template v-if="!selectedFile">
          <DragDropUpload
            id="upload-file"
            class="white"
            :description="$t('dragDrop.uploadFiles')"
            max-width="auto"
            given-height="80vh"
            :valid-formats="['application/pdf']"
            :current-file="selectedFile"
            :single-file="true"
            @uploaded="handleDragDrop"
          >
          </DragDropUpload>
        </template>
        <template v-else>
          <div>
            <v-overlay
              :absolute="true"
              :value="isUploading"
            >
              <v-progress-circular
                indeterminate
                size="64"
                color="primary"
              ></v-progress-circular>
            </v-overlay>
            <VisibleSignature
              ref="visibleSignature"
              :doc-data="documentBase64"
              :sign-prof="{}"
              @pdfLoaded="pdfLoaded"
            />
          </div>
        </template>
      </v-col>
    </v-row>
    <v-dialog v-model="authorizationModal" persistent max-width="500">
      <v-card id="explicit_auth_modal">
        <v-card-title>
          <span class="headline">{{ $t('documentSignatureCustomization.modal.authorization.title') }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="authorizationModalForm" v-model="authorizationModalFormValid" @submit.prevent>
            <v-text-field
              id="explicit_authmodal_textfield"
              ref="passwordField"
              v-model="expAuthPwd.pwd"
              tabindex="1"
              :append-icon="expAuthPwd.showPwd ? 'mdi-eye' : 'mdi-eye-off'"
              :label="$t('documentSignatureCustomization.modal.authorization.content.keyPassword') + `*`"
              :type="expAuthPwd.showPwd ? 'text' : 'password'"
              prepend-icon="mdi-lock"
              :rules="[rules.required, rules.passwordMustBeLongerThan]"
              @click:append="expAuthPwd.showPwd = !expAuthPwd.showPwd"
              @keydown.enter="signDoc()"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text tabindex="3" @click="authorizationModal = false">{{ $t('main.cancel') }}</v-btn>
          <v-btn
            id="explicit_authmodal_signbtn"
            color="success"
            tabindex="2"
            :disabled="!authorizationModalFormValid"
            :loading="authorizationModalBtnLoading"
            @click="signDoc()"
          >
            {{ $t('documentSignatureCustomization.modal.authorization.content.button.sign') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <implicit-authorization-modal
      :key="implicitAuthorizationModalKey"
      :signature-guid="implicitGuid"
      :request-loading-dialog-showed="implicitAuthorizationModalVisible"
    ></implicit-authorization-modal>
    <!-- SUCCESSFUL SIGN TOAST -->
    <v-row align="center" justify="center">
      <v-dialog v-model="successToastShowed" max-width="378">
        <v-card id="signature-toast" class="pa-10 ">
          <v-card-text style="text-align: center">
            <v-container>
              <v-row justify="center">
                <div id="success-text" class="text-h6" :class="'success--text'">
                  {{ $t('toastMessage.succesfullySigned') }}
                </div>
                <div>
                  {{ $t('pqcDemo.modal.text') }}
                </div>
                <v-row justify="center">
                  <v-btn
                    id="download-file" class="mt-6"
                    @click="downloadZip"
                  >
                    <v-icon class="mr-2">mdi-tray-arrow-down</v-icon>
                    {{ $t('dataTable.content.action.download') }}
                  </v-btn>
                </v-row>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import DragDropUpload from '@/components/DragDropUpload.vue'
import VisibleSignature from '@/components/VisibleSignature'
import ImplicitAuthorizationModal from './ImplicitAuthorizationModal'
import rsspUtil from '../../services/api/rsspUtil'
import { v4 as uuidv4 } from 'uuid'
import { showToastError } from '../../event-bus'
import CommonError from '../CommonError'
import CredentialAuthMode from './CredentialAuthMode'
import FileSaver from 'file-saver'
import signatures from '../../services/api/signatures'
import documents from '../../services/api/documents'

export default {
  name: 'QuantumSafeDemo',
  components: {
    DragDropUpload,
    VisibleSignature,
    ImplicitAuthorizationModal

  },
  data() {
    return {
      canSign: false,
      checkSignButtonDisabled: false,
      isUploading: false,
      selectedFile: null,
      documentBase64: null,
      selectedCredential: null,
      credentials: [],
      showBlueWarning: false, // check if needed,
      fileName: '',
      passwordMinCharacters: 4,
      rules: {
        required: (v) => !!v || !isNaN(parseFloat(v)) || this.$t('validation.form.requiredField'),
        passwordMustBeLongerThan: (v) => (v && v.length >= this.passwordMinCharacters) || this.$t('validation.form.passwordMustBeLongerThan', { min: this.passwordMinCharacters })
      },
      expAuthPwd: {
        pwd: null,
        showPwd: false
      },
      authorizationModalFormValid: false,
      authorizationModal: false,
      authorizationModalBtnLoading: false,
      // implicitAuthorizationModal
      implicitAuthorizationModalKey: 0,
      implicitGuid: '',
      devicesListTotalItems: 0,
      devicesActiveTotalItems: 0,
      implicitAuthorizationModalVisible: false,
      successToastShowed: false,
      signedDocDto: null
    }
  },
  computed: {
    singButtonDisabled() {
      return !(this.selectedFile && this.selectedCredential)
    }
  },
  async mounted() {
    await this.listMyActivatedCredentials()

    const devices = await rsspUtil.listMyDevices()
    this.devicesListTotalItems = devices.total
  },
  methods: {
    async downloadZip() {
      const { id } = this.signedDocDto
      const documentData = await documents.downloadDocument(id)
      await FileSaver.saveAs(documentData.slice(0, documentData.size, 'application/zip'), this.fileName)
    },
    showSuccessfulSign() {
      this.successToastShowed = true
    },
    async signDoc() {
      const docDto = await documents.uploadDocument(this.fileName, this.selectedFile)

      const signRequest = {
        credentialOptions: {}, // this.createCredentialOptions() // Call the method to create credential options
        origDocId: docDto.id
      }

      // Handle the signing process based on credential type

      const isImplicitCredential = this.selectedCredential.authMode === CredentialAuthMode.IMPLICIT

      // Check for implicit credential and handle device validation
      if (isImplicitCredential && this.devicesListTotalItems === 0) {
        showToastError(this.$t('documentSignatureCustomization.content.signature.activeCredentialButNoActivatedDeviceError'))
        return
      }

      // // Prepare documents options if the PDF is encrypted
      // if (this.pdfEncrypted && this.pdf_password) {
      //   signRequest.documentsOptions = [{
      //     docId: this.document.id,
      //     passwordProtection: this.pdf_password
      //   }]
      // }

      try {
        // Handle implicit authorization modal if needed
        if (isImplicitCredential) {
          this.implicitGuid = uuidv4()
          this.signRequest.credentialOptions.description = this.implicitGuid
          this.implicitAuthorizationModalKey++
          this.ImplicitAuthorizationModalVisible = true
        }

        if (this.selectedCredential) {
          signRequest.credentialOptions.credentialId = this.selectedCredential.id //

          if (!isImplicitCredential) {
            signRequest.credentialOptions.PIN = this.expAuthPwd.pwd
          }

          const signResponse = await signatures.pmSign(signRequest)
          this.signedDocDto = signResponse
          // this.back()
          this.showSuccessfulSign()
        }
      } catch (error) {
        if (error?.response?.data?.code === CommonError.SERVICE_UNAVAILABLE) {
          showToastError(this.$t('documentSignatureCustomization.content.signature.toastMessages.sicAborted'))
        }
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      } finally {
        this.authorizationModalBtnLoading = false
        this.isUploading = false
        this.ImplicitAuthorizationModalVisible = false
        this.authorizationModal = false
      }
    },

    showAuthorizationModal() {
      // if (!this.$refs.form.validate()) {
      //   return
      // }
      this.authorizationModal = true
      this.$nextTick(() => {
        this.$refs.authorizationModalForm.reset()
        this.$nextTick(() => {
          this.$refs.passwordField.focus()
        })
      })
    },
    async actionsWrapper() {
      // const docDto = await documents.uploadDocument(this.fileName, this.selectedFile)
      const docDto = { id: 'sdfsdfsd' }
      const signRequest = {

        origDocId: docDto.id,
        credentialOptions: {
          credentialId: this.selectedCredential.id
        }
      }
      if (this.selectedCredential.authMode === CredentialAuthMode.EXPLICIT) {
        this.showAuthorizationModal()
        signRequest.credentialOptions.PIN = this.expAuthPwd.pwd
      } else {
        this.implicitGuid = uuidv4()
        signRequest.credentialOptions.description = this.implicitGuid
      }
    },

    clearPdf() {
      this.selectedFile = null
      this.documentBase64 = null
      this.fileName = ''
    },
    getCredentialItemText(item) {
      if (item.provider) {
        return `${item.description} external: ${item.provider}`
      } else {
        return item.description
      }
    },
    async listMyActivatedCredentials() {
      try {
        const resp = await rsspUtil.listMyActivatedCredentials()
        resp.content = resp.content.filter(elem => ((elem.keyPurpose === 'ASYMMETRIC_SIGN') && (elem.keyAlg === 'sphincs+')))
        this.credentials = resp.content
        if (this.credentials.length === 1) {
          this.selectedCredential = this.credentials[0]
        }
        if (this.credentials.length === 0) {
          showToastError(this.$t('pqcDemo.errorToast'))
        }
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },
    handleDragDrop(e) {
      if (e === null) e = []
      this.selectedFile = e[0]
      this.fileName = e[0].name.slice(0, -4)
      this.convertToBase64()
    },
    convertToBase64() {
      if (this.selectedFile) {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.documentBase64 = event.target.result.split(',')[1]
        }
        reader.readAsDataURL(this.selectedFile)
      }
    },
    async pdfLoaded(variable) {
      this.pdfRendered = true
      this.isUploading = false
    }

  }

}
</script>
<style scoped></style>
